import {
  fetchStocks,
  fetchUserDetails,
  fetchUserFlags,
  updateUserFlags,
} from "./thunk";
import { setItemInStorage, setItemPersist } from "utils/storage";
import {
  ASIDE_STATE_KEY,
  SIGNUP_EMAIL_KEY,
  THEME_KEY,
  USER_WALKTHROUGH_FLAGS,
} from "utils/constants";

export const userDetailsReducer = (builder) => {
  builder.addCase(fetchUserDetails.pending, (state) => {
    state.user = null;
  });
  builder.addCase(fetchUserDetails.fulfilled, (state, action) => {
    state.user = action.payload;
  });
  builder.addCase(fetchUserDetails.rejected, (state) => {
    state.user = null;
  });
};

export const getStocksReducer = (builder) => {
  builder.addCase(fetchStocks.pending, (state) => {
    state.isLoadingStock = true;
    state.stockData = [];
  });
  builder.addCase(fetchStocks.fulfilled, (state, action) => {
    state.isLoadingStock = false;
    state.stockData = action.payload;
  });
  builder.addCase(fetchStocks.rejected, (state) => {
    state.isLoadingStock = false;
    state.stockData = [];
  });
};

export const getUserFlagsReducer = (builder) => {
  builder.addCase(fetchUserFlags.pending, () => {
    // Keep existing userFlags - don't clear
  });
  builder.addCase(fetchUserFlags.fulfilled, (state, action) => {
    state.userFlags = action.payload;
  });
  builder.addCase(fetchUserFlags.rejected, () => {
    // Keep existing userFlags on error
  });
};

export const updateUserFlagsReducer = (builder) => {
  builder.addCase(updateUserFlags.pending, (state) => {
    state.inAppOnboardingGuide.showCompletionModal = false;
  });
  builder.addCase(updateUserFlags.fulfilled, (state, action) => {
    const requiredFlags = Object.values(USER_WALKTHROUGH_FLAGS);
    const userFlags = action.payload;

    if (
      requiredFlags.every((flag) =>
        userFlags.some(
          (userFlag) => userFlag.flag === flag && userFlag.is_active
        )
      )
    ) {
      state.inAppOnboardingGuide.showCompletionModal = true;
    }

    state.userFlags = action.payload;
  });
  builder.addCase(updateUserFlags.rejected, (state) => {
    state.inAppOnboardingGuide.showCompletionModal = false;
  });
};

export const setScrollRefBottomReducer = (state, action) => {
  state.scrollRefBottom = action.payload;
};

export const setToastDataReducer = (state, action) => {
  state.toastData = action.payload;
};

export const setUserDetailsReducer = (state, action) => {
  state.user = action.payload;
};

export const setThemeReducer = (state, action) => {
  state.theme = action.payload;
  setItemPersist(THEME_KEY, action.payload);
};

export const clearUserStateReducer = (state) => {
  state.user = null;
};

export const setUserEmailReducer = (state, action) => {
  state.userEmail = action.payload;
  setItemInStorage(SIGNUP_EMAIL_KEY, action.payload);
};

export const setHasBannerReducer = (state, action) => {
  state.hasBanner = action.payload;
};

export const setScrollTopValueReducer = (state, action) => {
  state.scrollTopValue = action.payload;
};

export const setCollapsedSidebarReducer = (state, action) => {
  state.collapsedSidebar = action.payload;
  setItemInStorage(ASIDE_STATE_KEY, String(!action.payload));
};

export const toggleUpgradePremiumModalReducer = (state, action) => {
  state.showUpgradePremiumModal = action.payload;
};

export const togglePremiumPlanModalReducer = (state) => {
  state.showPremiumPlanModal = !state.showPremiumPlanModal;
};

export const togglePurchasePlanModalReducer = (state, action) => {
  state.showPurchasePlanModal = action.payload;
};

export const setLockModalReducer = (state, action) => {
  state.lockModal = {
    ...state.lockModal,
    ...action.payload,
  };
};

export const toggleUnsupportedBankModalReducer = (state, action) => {
  state.showUnsupportedBankModal = action.payload;
};

export const toggleWelcomeModalReducer = (state, action) => {
  state.inAppOnboardingGuide.showWelcomeModal = action.payload;
};

export const toggleGetStartedPanelReducer = (state, action) => {
  state.inAppOnboardingGuide.showGetStartedPanel = action.payload;
};

export const toggleGetStartedToggleButtonReducer = (state, action) => {
  state.inAppOnboardingGuide.showToggleButton = action.payload;
};

export const setShowFeatureDetailsKeyReducer = (state, action) => {
  state.inAppOnboardingGuide.showFeatureDetailsKey = action.payload;
};

export const toggleStartGuideModalReducer = (state, action) => {
  state.inAppOnboardingGuide.showStartGuideModal = action.payload;
};

export const setMarketplaceStrategyIdReducer = (state, action) => {
  state.inAppOnboardingGuide.marketplaceStrategyId = action.payload;
};

export const setWalkthroughReducer = (state, action) => {
  state.inAppOnboardingGuide.walkthrough = action.payload;
};

export const setWelcomeWalkthroughReducer = (state, action) => {
  state.inAppOnboardingGuide.welcomeWalkthrough = action.payload;
};

export const setIdleTimerReducer = (state, action) => {
  state.isUserIdle = action.payload;
};

export const toggleSuggestedstrategyModalReducer = (state, action) => {
  state.showSuggestedStrategyModal = action.payload;
};

export const toggleCompletionModalReducer = (state, action) => {
  state.inAppOnboardingGuide.showCompletionModal = action.payload;
};

export const toggleCreateStrategyModalReducer = (state, action) => {
  state.showCreateStrategyModal = action.payload;
};

export const setBreadcrumbDetailNameReducer = (state, action) => {
  state.breadcrumbDetailName = action.payload || "";
};

export const clearBreadcrumbDetailNameReducer = (state) => {
  state.breadcrumbDetailName = "";
};
